<template lang="pug">
#page_components.page
	Banner(v-bind:item='list_banner_full', classes='half')
	br
	Banner(v-bind:item='list_banner_full', classes='list')
	br
	Banner(v-bind:item='item_banner_full', classes='')
	br
	.container
		.row
			.col-md-4
				CardVertical(v-bind:item='items_card_vertical[0]', classes='index')
			.col-md-4
				CardVertical(
					v-bind:item='items_card_vertical[1]',
					classes='nominee trophy'
				)
			.col-md-4
				CardVertical(v-bind:item='items_card_vertical[2]', classes='')
	.container-fluid.px-md-0
		.row
			.col-md-4
				CardFull(v-bind:item='items_card_full[0]', classes='')
			.col-md-4
				CardFull(v-bind:item='items_card_full[1]', classes='')
			.col-md-4
				CardFull(v-bind:item='items_card_full[2]', classes='')
	.container
		.row
			.col-md-4.position-relative
				CardFull(v-bind:item='items_card_full[0]', classes='detail')
</template>

<script>
import Banner from '@/components/Banner.vue';
import CardFull from '@/components/CardFull.vue';
import CardVertical from '@/components/CardVertical.vue';
export default {
	data() {
		return {
			list_banner_full: {
				media: 'assets/images/demo.jpg',
				category: '年度主題',
				title: '未來旋轉門',
				title_en: '',
				desc: '本屆以「信念與希望」作為影展核心價值，透過影片探究與挖掘孩子的「修復力」，並以此為核心鼓勵小朋友在成長過程中，面對各式各樣的大小困難，除了要無所 畏懼地面對種種挑戰，更要從擁抱挫折的過程裡，成長出屬於自己的勇敢力量。',
				badges: [],
			},
			item_banner_full: {
				media: 'assets/images/demo.jpg',
				category: '開幕片',
				title: '再見的那一天',
				title_en: 'Fritzi - A Revolutionary Tale',
				desc: '在1989年的東德，12歲的費琪受好友蘇菲之託，在蘇菲去鄰國匈牙利度假時，幫忙照顧小狗，但是蘇菲卻一去不回。',
				badges: ['台灣首映', '開閉幕片', '友情'],
			},
			items_card_full: [
				{
					id: 0,
					image: 'assets/images/demo.jpg',
					badge: '開幕片',
					title: '外公的滾球賽',
					desc: '劇情長片 | 92 分鐘 | 普 | 0+',
				},
				{
					id: 0,
					image: 'assets/images/demo.jpg',
					title: '女孩不設限',
					desc: '劇情長片 | 92 分鐘 | 普 | 0+',
				},
				{
					id: 0,
					image: 'assets/images/demo.jpg',
				},
			],
			items_card_vertical: [
				{
					id: 0,
					date: '2022-01-07T16:47:24',
					image: 'assets/images/demo.jpg',
					title: '2020國際競賽得獎名單出爐 荷蘭《時光髮廊》奪最佳劇情長片 《年尾巴》掄台灣獎',
					desc: '「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情',
				},
				{
					id: 0,
					image: 'assets/images/demo.jpg',
					title: '女孩不設限',
					desc: '劇情長片 | 92 分鐘 | 普 | 0+ </br> 劉晏呈、鄭煥宙、陳嘉言、瑪琳．凡爾桂、田娜．傑洛維希 ',
				},
				{
					id: 0,
					image: 'assets/images/demo.jpg',
					title: '2020國際競賽得獎名單出爐 荷蘭《時光髮廊》奪最佳劇情長片 《年尾巴》掄台灣獎',
					title_en: 'TESTTEST EN',
					brief: '台灣 | 劇情長片 | 92 分鐘 | 普 | 0+',
					desc: '「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情',
				},
			],
			item_preview: {
				id: 0,
				image: 'assets/images/demo.jpg',
				title: '2020國際競賽得獎名單出爐 荷蘭《時光髮廊》奪最佳劇情長片 《年尾巴》掄台灣獎',
				title_en: 'TESTTEST EN',
				brief: '台灣 | 劇情長片 | 92 分鐘 | 普 | 0+',
				desc: '「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情「2020台灣國際兒童影展」，6月29日公布國際競賽得獎名單。描寫女孩與失智外婆間情描寫女孩與失智外婆間情描寫女孩與失智外婆間情',
			},
		};
	},
	components: {
		CardFull,
		CardVertical,
		Banner,
	},
};
</script>
